import React, { useEffect, useState } from "react";
import NikeLogo from "../assets/favicon.ico";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrderWithCardAsync,
  selectCurrentOrder,
  selectOrderCardPaymentData,
  validateOrderWithCardAsync,
} from "../features/order/orderSlice";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const CheckoutCardPayment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const cardPaymentData = useSelector(selectOrderCardPaymentData);
  const currentOrder = useSelector(selectCurrentOrder);
  const [reload, setReload] = useState(false);
  const razorPayData = (data) => {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Enter the Key ID generated from the Dashboard
      amount: data.order.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: data.order.currency,
      name: "NIKE",
      description: "Test Transaction",
      image: NikeLogo,
      order_id: data.order.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      handler: function (response) {
        navigate(`/orderSuccess/${currentOrder.id}`);
      },
      prefill: {
        name: "Subham Das",
        email: "sdas69629@gmail.com",
        contact: "8339483394",
      },
      notes: {
        address: "Razorpay Corporate Office",
        orderId: currentOrder.id,
      },
      theme: {
        color: "#000",
      },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
    rzp.on("payment.failed", function (response) {
      navigate("/paymentFailed");
    });
  };
  useEffect(() => {
    if (currentOrder && Object.keys(currentOrder).length > 0) {
      dispatch(createOrderWithCardAsync(currentOrder));
    }
  }, [dispatch, currentOrder]);
  useEffect(() => {
    if (cardPaymentData) {
      razorPayData(cardPaymentData);
    }
  }, [cardPaymentData, reload]);
  useEffect(() => {
    Swal.close();
  }, [location]);
  return (
    <div className="w-full h-screen flex items-center flex-col justify-center">
      <div className="">
        {" "}
        <div className="w-full my-4 flex justify-center">
          <div
            className="inline-block  h-8 w-8 animate-spin rounded-full  border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          >
            <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
              Loading...
            </span>
          </div>
        </div>
      </div>
      <div className="w-64 ">
        <h1 className="text-2xl text-center">Processing your payment</h1>
        <h1 className="text-2xl text-center">Please wait patiently</h1>
      </div>
      <div className="opacity-0">
        {setTimeout(() => {
          Swal.fire({
            title: `Do you want to restart the payment procedure ?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "red",
            confirmButtonText: "Yes, restart the payment procedure",
            cancelButtonText: "No, get me back to login page",
          }).then((result) => {
            if (result.isConfirmed) {
              setReload(!reload);
            } else {
              navigate("/home");
            }
          });
        }, 3000)}
      </div>
    </div>
  );
};

export default CheckoutCardPayment;
